import { render, staticRenderFns } from "./OnlCgformErpList.vue?vue&type=template&id=61461aea&scoped=true&"
import script from "./OnlCgformErpList.vue?vue&type=script&lang=js&"
export * from "./OnlCgformErpList.vue?vue&type=script&lang=js&"
import style0 from "./OnlCgformErpList.vue?vue&type=style&index=0&id=61461aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61461aea",
  null
  
)

export default component.exports